import React, { Component } from 'react';
import InputMask from '../input_mask/InputMask';
import { Icon, Table, Button } from 'antd';
import { makeMsisdnBeautiful } from '../../Utils';
import AnimateEnter from '../AnimateEnter';
import MESSAGES from '../../locale/messages';
import TEXTS from '../../locale/texts';
import { showMsisdnsColumns } from './columns/showMsisdnsColumns';

class ShowMsisdns extends Component {
  state = {
    msisdn: '',
    tableData: this.props.msisdns,
    currentPage: 1,
    pageSize: 10,
    isMounted: true
  };

  columns = showMsisdnsColumns.bind(this);

  onInputChange = (event) => {
    const msisdnValue = event.target.value.replace(/\D/g, '');
    this.setState({ msisdn: msisdnValue });
  };

  onMsisdnEnterClicked = () => {
    const { msisdn } = this.state;
    if (msisdn.length === 11) this.removeMsisdn();
  };

  onCancel = () => {
    const { hideDrawer } = this.props;
    this.setState({ msisdn: '', tableData: [] });
    hideDrawer();
  };

  removeMsisdn = (_msisdn) => {
    this.setState(({ tableData, currentPage, pageSize }) => {
      // update currentPage on removeMsisdn
      // because it updates only on click
      // pagination button number
      // because we use it inside
      // index counting for msisdn
      // inside table with all the msisdns
      // this case happens if we delete
      // all the numbers from the last page
      const msisdnsArrayLengthAfterDeleteOne = tableData.length - 1;
      return {
        msisdn: '',
        tableData: tableData.filter(({ msisdn }) => msisdn !== _msisdn),
        currentPage:
          (msisdnsArrayLengthAfterDeleteOne / pageSize) < currentPage
            && (msisdnsArrayLengthAfterDeleteOne % pageSize) === 0
          ? currentPage - 1
          : currentPage
      }
    });
  };

  updateMsisdns = () => {
    const { substituteMsisdns, hideDrawer } = this.props;
    const { tableData } = this.state;
    substituteMsisdns(tableData);
    this.setState({ msisdn: '', tableData: [] });
    hideDrawer();
  };

  render() {
    const { name, lang, msisdns } = this.props;
    const { tableData, msisdn: msisdnInput, pageSize, isMounted } = this.state;
    const columns = this.columns();

    const matcher = new RegExp(`^${msisdnInput.replace('\s', '')}`);
    const msisdnsList = !!msisdnInput
      ? tableData.filter(({ msisdn: _msisdn }) => _msisdn.match(matcher))
      : tableData;

    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="t-light">
            {MESSAGES.allReceiversForCampaignName(name, tableData.length)[lang]}
          </h3>
          <div>
            <Button
              type="primary"
              size="large"
              style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 14}}
              disabled={tableData.length === msisdns.length}
              onClick={this.updateMsisdns}
            >
              {TEXTS.btnSave[lang]}
            </Button>
            <Button
              style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 14}}
              onClick={this.onCancel}
            >
              {tableData.length === msisdns.length ? TEXTS.btnClose[lang] : TEXTS.btnToCancel[lang]}
            </Button>
          </div>
        </div>
        <div className="mb-4">
          <label className="t-bold">{TEXTS.phoneNumberSearchLabel[lang]}</label>
          <div className="mb-lg-0 d-flex">
            <div className="position-relative">
              <InputMask
                type="text"
                className="form-control mr-3"
                placeholder="+7-___-___-__-__"
                style={{ height: '50px', width: 'auto' }}
                value={msisdnInput}
                onChange={this.onInputChange}
                onKeyDown={this.onMsisdnEnterClicked}
                mask="+7-111-111-11-11"
              />
            </div>
          </div>
        </div>
        <AnimateEnter paginationAnimate={{ isMounted }}>
          <Table
            columns={columns}
            dataSource={msisdnsList}
            size="middle"
            rowKey={({ msisdn }) => msisdn}
            pagination={{
              pageSize,
              hideOnSinglePage: true,
              size: 'large',
              onChange: (page) => {
                this.setState({
                  currentPage: page,
                  isMounted: false
                });
                setTimeout(() => {
                  this.setState({ isMounted: true });
                }, 0);
              }
            }}
          />
        </AnimateEnter>
      </div>
    );
  }
}

export default ShowMsisdns;
